import {Chip} from '@dropbox/dig-components/chip';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {Truncate} from '@dropbox/dig-components/truncate';
import {atoms, Box, withShade} from '@dropbox/dig-foundations';
import {Link} from 'components/DSYS/Link';
import {LinkIcon, linkToIcon} from 'components/shared/LinkIcon';
import {MouseEvent} from 'react';
import {
  dashboardLinkDestination,
  logDashboardInteraction,
} from 'views/home/dashboard/dashboardAnalytics';
import {useDashboardTileId} from 'views/home/dashboard/DashboardTileContext';

/** Max pixel width for link label truncation inside the agenda tile. */
const CHIP_LABEL_MAX_WIDTH = 160;

export const AgendaLinkChip = ({
  url,
  label,
  isLive,
  maxLabelWidth = CHIP_LABEL_MAX_WIDTH,
}: {
  url: string;
  label: string;
  isLive: boolean;
  /** Where the chip has a line to itself, its label can run longer. */
  maxLabelWidth?: number;
}) => {
  const tileId = useDashboardTileId();

  return (
    <Tooltip placement="top" title={url}>
      <Link
        hasNoUnderline
        monochromatic
        to={url}
        rel="noopener noreferrer"
        aria-label={`${label}. ${url}`}
        {...withShade({
          className: atoms({
            borderRadius: 'Large',
            display: 'inline-flex',
            cursor: 'pointer',
            textDecoration: 'none',
            backgroundColor: isLive
              ? {
                  default: 'Primary Surface - State 1',
                  hover: 'Primary Surface - State 2',
                }
              : 'transparent',
          }),
        })}
        onClick={(e: MouseEvent) => {
          e.stopPropagation();
          if (tileId) {
            logDashboardInteraction({
              action: 'link_click',
              tileId,
              target: label,
              destination: dashboardLinkDestination(url),
            });
          }
        }}
      >
        <Chip
          type="button"
          tabIndex={-1}
          size="small"
          variant={isLive ? 'transparent' : 'standard'}
          onClick={undefined}
          style={{pointerEvents: 'none'}}
        >
          <Chip.IconAccessory>
            <LinkIcon icon={linkToIcon(url)} size="small" className={atoms({flexShrink: 0})} />
          </Chip.IconAccessory>
          <Chip.Content>
            <Box paddingRight="4" style={{minWidth: 0, maxWidth: maxLabelWidth}}>
              <Truncate location={0.5} observeParent>
                {label}
              </Truncate>
            </Box>
          </Chip.Content>
        </Chip>
      </Link>
    </Tooltip>
  );
};
